module.exports = __webpack_public_path__ + "static/img/GXZWY.96074ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/GXZWY.png
// module id = B12A
// module chunks = 1